import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Search } from "@material-ui/icons";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import BetterSelect from "../../components/BetterSelect";
import InputCustom from "../../components/InputCustom";
import * as viagem_crud from "../../crud/viagem.crud";
import * as equipe_crud from "../../crud/equipe.crud";
import { formatDateTimeLocal } from "../../utils/Utils";
import { obterStatusInfo, OPCOES_FILTRO_STATUS } from "./ViagemUtils";
import styles from "../../styles/Viagem.module.scss";

class ViagemIndex extends Component {
  state = {
    viagens: [],
    loading: true,
    total: 0,
    page: 1,
    per_page: 9,
    filtro_data_inicial: "",
    filtro_data_final: "",
    filtro_passageiro: "",
    filtro_status: "",
    colaboradores: [],
  };

  componentDidMount() {
    this.buscarViagens();
    this.buscarColaboradores();
  }

  buscarColaboradores = () => {
    equipe_crud.getDataTable({ rows: 9999, page: 0 })
      .then((res) => {
        this.setState({ colaboradores: res.data.data.data || [] });
      })
      .catch(() => {
        this.setState({ colaboradores: [] });
      });
  };

  buscarViagens = () => {
    const {
      filtro_data_inicial,
      filtro_data_final,
      filtro_passageiro,
      filtro_status,
      page,
      per_page,
    } = this.state;

    this.setState({ loading: true });

    viagem_crud.getDataTable({
      data_inicial: filtro_data_inicial,
      data_final: filtro_data_final,
      passageiro_id: filtro_passageiro,
      status: filtro_status,
      page,
      per_page,
    })
      .then((res) => {
        this.setState({
          viagens: res.data.data || [],
          total: res.data.total || 0,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ viagens: [], total: 0, loading: false });

        Swal.fire({
          icon: "error",
          title: "Erro",
          text: err?.response?.data?.errors?.[0] || "Erro ao buscar viagens.",
        });
      });
  };

  handleFiltrar = () => {
    this.setState({ page: 1 }, () => {
      this.buscarViagens();
    });
  };

  handlePagina = (nova_pagina) => {
    this.setState({ page: nova_pagina }, () => {
      this.buscarViagens();
    });
  };

  handleExportarRelatorio = () => {
    const {
      filtro_data_inicial,
      filtro_data_final,
      filtro_passageiro,
      filtro_status,
    } = this.state;

    viagem_crud.exportarRelatorio({
      data_inicial: filtro_data_inicial,
      data_final: filtro_data_final,
      passageiro_id: filtro_passageiro,
      status: filtro_status,
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
        const link = document.createElement("a");
        const nome_arquivo = `viagens_${new Date().toISOString().slice(0, 10)}.csv`;

        link.href = url;
        link.setAttribute("download", nome_arquivo);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao exportar relatório.",
        });
      });
  };

  renderPaginacao = () => {
    const { page, per_page, total } = this.state;
    const total_paginas = Math.ceil(total / per_page);

    if (total_paginas <= 1) {
      return null;
    }

    const paginas = [];

    for (let numero = 1; numero <= total_paginas; numero++) {
      paginas.push(
        <button
          key={numero}
          className={numero === page ? styles.paginacaoBotaoAtivo : styles.paginacaoBotao}
          onClick={() => this.handlePagina(numero)}
          disabled={numero === page}
        >
          {numero}
        </button>
      );
    }

    const primeiro_item = (page - 1) * per_page + 1;
    const ultimo_item = Math.min(page * per_page, total);

    return (
      <div className={styles.paginacao}>
        <span className={styles.paginacaoInfo}>
          Mostrando {primeiro_item}-{ultimo_item} de {total} resultados
        </span>

        <div className={styles.paginacaoBotoes}>
          <button
            className={styles.paginacaoBotao}
            onClick={() => this.handlePagina(page - 1)}
            disabled={page === 1}
          >
            &lt;
          </button>

          {paginas}

          <button
            className={styles.paginacaoBotao}
            onClick={() => this.handlePagina(page + 1)}
            disabled={page === total_paginas}
          >
            &gt;
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      viagens,
      loading,
      filtro_data_inicial,
      filtro_data_final,
      filtro_passageiro,
      filtro_status,
      colaboradores,
    } = this.state;

    return (
      <div className={styles.container}>
        <p className={styles.titulo}>Viagens</p>

        <div className={styles.filtrosContainer}>
          <div className={styles.filtroGroup}>
            <InputCustom
              label="Data inicial"
              name="filtro_data_inicial"
              type="date"
              value={filtro_data_inicial}
              onChange={(evento) =>
                this.setState({ filtro_data_inicial: evento.target.value }, this.handleFiltrar)
              }
            />
          </div>

          <div className={styles.filtroGroup}>
            <InputCustom
              label="Data final"
              name="filtro_data_final"
              type="date"
              value={filtro_data_final}
              onChange={(evento) =>
                this.setState({ filtro_data_final: evento.target.value }, this.handleFiltrar)
              }
            />
          </div>

          <div className={styles.filtroGroup}>
            <BetterSelect
              label="Passageiro"
              value={filtro_passageiro}
              onChange={(evento) =>
                this.setState({ filtro_passageiro: evento.target.value }, this.handleFiltrar)
              }
            >
              <option value="">Todos</option>
              {colaboradores.map((colaborador) => (
                <option key={colaborador.id} value={colaborador.id}>
                  {colaborador.usr_nome}
                </option>
              ))}
            </BetterSelect>
          </div>

          <div className={styles.filtroGroup}>
            <BetterSelect
              label="Status da viagem"
              value={filtro_status}
              onChange={(evento) =>
                this.setState({ filtro_status: evento.target.value }, this.handleFiltrar)
              }
            >
              {OPCOES_FILTRO_STATUS.map((opcao) => (
                <option key={opcao.valor} value={opcao.valor}>
                  {opcao.label}
                </option>
              ))}
            </BetterSelect>
          </div>
        </div>

        <span className={styles.divisor} />

        <div className={styles.botoesListagem}>
          <Button
            type="button"
            variant="primary"
            size="md"
            outlined
            onClick={this.handleExportarRelatorio}
          >
            Exportar relatório&nbsp;&nbsp;<span class="material-symbols-outlined">download</span>
          </Button>

          <Link to="/viagens/novo" style={{ textDecoration: "none" }}>
            <Button type="button" variant="primary" size="md">
              Solicitar Chof&nbsp;&nbsp;+
            </Button>
          </Link>
        </div>

        <BetterCircularProgress loading={loading} />

        {!loading && viagens.length === 0 && (
          <div className={styles.emptyState}>
            <Search className={styles.emptyIcone} style={{ fontSize: 56 }} />

            <p className={styles.emptyTitulo}>Nenhuma viagem encontrada</p>
            <span className={styles.emptyDescricao}>
              Solicite uma viagem para começar a utilizar o serviço.
            </span>

            <Button
              type="button"
              variant="primary"
              size="md"
              onClick={() => this.props.history.push("/viagens/novo")}
            >
              Solicitar Chof +
            </Button>
          </div>
        )}

        {!loading && viagens.length > 0 && (
          <>
            <div className={styles.viagensGrid}>
              {viagens.map((viagem) => {
                const status_info = obterStatusInfo(viagem.via_status);

                const nome_motorista = viagem.motorista?.mot_nome || "Aguardando confirmação";

                let info_veiculo = "Aguardando confirmação";

                if (viagem.veiculo) {
                  info_veiculo = `${viagem.veiculo.vei_placa} - ${viagem.veiculo.vei_modelo} - ${viagem.veiculo.vei_cor}`;
                }

                return (
                  <div
                    key={viagem.id}
                    className={styles.viagemCard}
                    onClick={() => this.props.history.push(`/viagens/${viagem.id}`)}
                  >
                    <div className={styles.viagemCardHeader}>
                      <div>
                        <p className={styles.viagemPassageiro}>
                          {viagem.passageiro?.usr_nome || "Passageiro"}
                        </p>
                        <p className={styles.viagemData}>
                          {formatDateTimeLocal(viagem.via_data_agendamento)}
                        </p>
                      </div>

                      <span className={styles[status_info.classeKey]}>
                        {status_info.label}
                      </span>
                    </div>

                    <div className={styles.viagemDetalhes}>
                      <div>
                        <p className={styles.viagemLabel}>Motorista</p>
                        <p className={styles.viagemValor}>{nome_motorista}</p>
                      </div>

                      <div>
                        <p className={styles.viagemLabel}>Veículo</p>
                        <p className={styles.viagemValor}>{info_veiculo}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {this.renderPaginacao()}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(ViagemIndex);
